import { chargeMonthKey } from "./chargeDates";

const recurringDateForMonth = (payment, month) => {
  const sourceDate = String(
    payment.paymentFrom || payment.date || "",
  ).slice(0, 10);
  const day = Number(sourceDate.slice(8, 10)) || 1;
  const [year, monthNumber] = month.split("-").map(Number);
  const lastDay = new Date(Date.UTC(year, monthNumber, 0)).getUTCDate();
  return `${month}-${String(Math.min(day, lastDay)).padStart(2, "0")}T00:00:00.000Z`;
};

export const paymentsForMonth = (payments = [], month = "") =>
  (Array.isArray(payments) ? payments : []).flatMap((payment) => {
    const storedMonth = String(payment.paymentMonth || "").slice(0, 7);
    const startMonth =
      chargeMonthKey(payment.paymentFrom || payment.date) || storedMonth;
    const endMonth = chargeMonthKey(payment.paymentTo);
    const isRecurring = payment.billingType === "recurring";

    if (!isRecurring) {
      return (storedMonth || startMonth) === month ? [payment] : [];
    }
    if (!startMonth || month < startMonth || (endMonth && month > endMonth)) {
      return [];
    }

    return [
      {
        ...payment,
        date: recurringDateForMonth(payment, month),
        paymentMonth: month,
        sourceDate: payment.sourceDate ?? payment.date,
      },
    ];
  });
